import { render } from "./RegistrationForm.vue?vue&type=template&id=de1043f8&scoped=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=de1043f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-de1043f8"

export default script